import { coinIcon } from "~/assets/assets";

export type CoinsBalanceDisplayProps = {
  balance: number;
  onClick?: () => void;
};

export function CoinsBalanceDisplay(props: CoinsBalanceDisplayProps) {
  return (
    <div
      class=" inline-flex cursor-pointer items-center justify-center gap-2 rounded-full border border-stroke-2 bg-background-normal-primary px-4 py-[4.5px] !transition-none hover:bg-background-normal-secondary"
      onClick={props.onClick}
    >
      <div class="flex items-center gap-[6px]">
        <span class="text-para-3-medium text-text-normal-secondary">
          Balance
        </span>
        <img src={coinIcon} alt="" class="h-5 w-5" />

        <span class="text-para-3-medium text-text-normal-primary">
          {props.balance.toLocaleString()}
        </span>
      </div>
    </div>
  );
}
